var x_helper = function (){};

x_helper.prototype = {
    content: {
        reload: function () {
            location = location;
        },
		load:function(url, options){
			url = url || location.pathname + location.search;
			if (options === undefined || options === null){
				options = {};
				if (typeof content_load_target !== 'undefined'){
					options.target = content_load_target;
				}

				if (typeof content_load_history !== 'undefined'){
					options.history = false;
				}
			}
			
			//debugger;
			let target = $('#' + ((options.target) ? options.target : 'content')),
				data = ((options.data) ? options.data : {});
			
			loadingbar.start();
			//debugger;
			target.load(url, data, function(response, status){
                
				if (status === 'error'){
					loadingbar.stop();
                    window.location = url;
					return;
				}
				
				if (options.history !== false){
					window.history.pushState({path: url},'',url);
				}
				dispatchEvent(new Event('load'));
                //xlisteners.ajax();
                xlisteners.init();
				loadingbar.stop();
				//alert(content_load_target);
			});
		},
        _load: function (url, data) {
			
			url = url || location.pathname + location.search;
            // Naikiname #hash dalį
            url.replace(/#.*/, '');
			
			xdialog.close();
			var params = xhelper.url.setParams(data);
			location = url + params;
        },
        title: function (title){
			var decoded = $('<div/>').html(title).text();
			document.title = (role.developer ? params.solution.replace('crm_', ' ') : '').replace('_crm',' ') + decoded;
        }
    },
    json: {
        parse: function (value){
            if (!value) {
                return [];
            }

            return JSON.parse(value);
        }
    },
    url: {
        urlParams: function(data, update) {
            //pj 19-09-02
            if(!update){
                window.history.pushState(null, null, xhelper.url.setParams(data));
                return;
            }

            const params = new URLSearchParams(location.search);
            
            $.each(data, function(name, val){
                params.set(name, val);
            });

            window.history.replaceState({ }, "", decodeURIComponent(`${ location.pathname}?${ params}`));
        },
        /** Gauna visus GET parametrus, saveikauja
         * @return {object}
         */
        getParams: function(){
            var query = location.search.substr(1) || undefined;
            if (query === undefined) {
                return {};
            }

            var result = {};
            query.split('&').forEach(function (part){
                var item = part.split('='),
                    key = item[0],
                    value = decodeURIComponent(item[1]);
                try {
                    result[key] = JSON.parse(value);
                } catch (e) {
                    result[key] = value;
                }
            });

            return result;
        },
        setParams: function (params){
            /** GRAZINA URL GET'a
             * @param {params} - GET parametru objektas
             * returns object
             */
            var query = Object.keys(params);
            // debugger;
			if (query.length === 0){
                return '';
            }
            var result = query.map((key) => {
				if (typeof params[key] == 'object' && params[key] instanceof Array === false){
					if (Object.keys(params[key]).length === 0) {
						return '';
					}
					return (this.encode(key) + '=' + this.encodeJson(params[key]));
				} else if (params[key] instanceof Array === true && params[key].length === 0){
					return '';
				}

				return (this.encode(key) + '=' + this.encode(params[key]));
			}); // .clean(); Array.prototype.clean

            if (result.length === 0) {
                return '';
            }

            return '?' + result.join('&');
        },
        getParam: function(key){
            var params = this.getParams();
			return params[key];
        },
        setParam: function (key, value, encode) {
            var params = this.getParams();

            params[key] = value;

            if ((encode || false) === false) {
                return this.setParams(params);
            }

            return this.setParams(this.encode(params));
        },
        encode: function(value){
            return encodeURIComponent(value);
        },
        encodeJson: function (value) {
            return encodeURIComponent(JSON.stringify(value));
        },
        /**
         * Patikrina, ar failas gali turėti peržiūros nuotrauką (nuotrauka, dokumentas, video...)
         * Jeigu gali - grąžina peržiūros URL, jeigu ne - empty string
         * @param {string} path - failo būvimo vieta (/upload/.../nuotrauka.jpg)
         * @param {number} size - norimas nuotraukos dydis (prie Retina ekranu atitinkamai didės)
         * @param {boolean} cropped - Jeigu `true`, nuotrauka apkarpoma, kitu atveju - ne (išlaikoma nuotraukos proporcija)
         * @return {string}
         */
        getPreviewUrl: function (path, size, cropped) {
            size = size || 100;
			cropped = ((cropped === false) ? false : true); 
			
			if (!path) return '';

            const isImage = xhelper.file.isImage(path);
            const isDocument = xhelper.file.isDocument(path);
            if (isImage === false && isDocument === false) return '';

            const tSize = parseInt(size * window.devicePixelRatio);
            if (isImage === true) {
                const sizeStr =
                    (cropped === true ? 'f' : '') + tSize.toString();
                return path.replace(
                    '/upload/',
                    '/upload/cache/' + sizeStr + 'x' + sizeStr + '/'
                );
            }
            const converterUrl = location.origin + '/blanks/generateExisting/';
            const absPath = location.origin + encodeURIComponent(path);
            return (
                converterUrl +
                '?fileurl=' +
                absPath +
                '&output=jpg&width=' +
                tSize +
                '&height='+tSize+
                '&crop=' +
                (cropped === true ? '1' : '0')
            );
        },
		setParamSilent:function(param, data){
			var params = this.getParams();
			params[param] = data;
			
			var q = this.setParams(params),
				l =  window.location.pathname,
				j = l+q;
			//debugger;
			
			window.history.pushState(null, null, j);
		}
    },
    string: {
        random: function (){
            return Math.random()
                .toString(36)
                .substring(7);
        },
        guid: function (){
            return (
                Math.random()
                .toString(36)
                .substring(2, 15) +
                Math.random()
                .toString(36)
                .substring(2, 15)
            );
        },
        replicate: function (string, times) {
            return Array(times + 1).join(string);
        },
        truncate: function (str, len, start) {
            start = start || 0;
            return jQuery
                .trim(str)
                .substring(start, len)
                .trim(this);
        },
        isInteger: function (x) {
            return (x ^ 0) == x;
        },
		escapeHtml: function(unsafe){
			return $('<div />').text(unsafe).html();
		},
		unescapeHtml: function(safe) {
			return $('<div />').html(safe).text();
		},
		aliasify:function(str){
		  var lt_map = {
			ą: "a",
			č: "c",
			ę: "e",
			ė: "e",
			į: "i",
			š: "s",
			ų: "u",
			ū: "u",
			ž: "z",
			Ą: "A",
			Č: "C",
			Ę: "E",
			Ė: "E",
			Į: "I",
			Š: "S",
			Ų: "U",
			Ū: "U",
			Ž: "Z"
		  };

		  var ascii = str.replace(/[^a-zA-Z]/g, function(l) {
			return lt_map[l] || l;
		  });

		  return ascii
			.toLowerCase()
			.replace(/\s\s+/g, " ")
			.trim()
			.replace(/\s/g, "-");
        },
        commafy: function(str) {
            return str.replace(/(^|[^\w.])(\d{4,})/g, function($0, $1, $2) {
                return $1 + $2.replace(/\d(?=(?:\d\d\d)+(?!\d))/g, "$& ");
            });
        }
    },
    functions: {
        question: function (title, text, config, callback) {
            var defaults = {
                icon: 'fa fa-question-circle',
                content: text,
                title: title,
                keyboardEnabled: true,
                animationSpeed: 400,
                animationBounce: 1.3,
                animation: 'zoom',
                closeAnimation: 'zoom',
                backgroundDismiss: true,
                theme: 'material',
                buttons: {
                    ok: {
                        text: lang['confirm'],
                        btnClass: config.success_color || 'btn-success',

                        action: function () {
                            callback(true);
                        }
                    },
                    cancel: {
                        text: lang['cancel'],
                        btnClass: 'btn-default pull-left',

                        action: function () {
                            callback(false);
                        }
                    }
                },
                post: false,
                dialogClass: 'modal-dialog'
            };

            $.extend(defaults, config);
            $.confirm(defaults);
        }
    },
    obj: {
        length: function (obj) {
            return Object.keys(obj).length;
        },
        isEmpty: function (obj) {
            return Object.keys(obj).length === 0;
        },
        index: function (obj, key, value) {
            for (var b = 0; b < obj.length; b++) {
                if (obj[b][key] == value) {
                    return b;
                }
            }

            return undefined;
        },
        toArray: function (obj) {
            return $.map(obj, function (value) {
                return [value];
            });
        }
    },
    array: {
        in_array: function (string, array) {
            return array.includes(string);
        },
        move: function (array, old_index, new_index) {
            var length = array.length;

            if (new_index >= length) {
                var k = new_index - length;
                while (k-- + 1) {
                    array.push(undefined);
                }
            }
            array.splice(new_index, 0, array.splice(old_index, 1)[0]);
        },
        toObj: function (arr) {
            var rv = {};
            for (var i = 0, l = arr.length; i < l; ++i) {
                if (arr[i] !== undefined) {
                    rv[i] = arr[i];
                }
            }
            return rv;
        }
    },
    screen: {
        isMobile: {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (
                    isMobile.Android() ||
                    isMobile.BlackBerry() ||
                    isMobile.iOS() ||
                    isMobile.Opera() ||
                    isMobile.Windows()
                );
            }
        },
        detectIE: function () {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(
                    ua.substring(msie + 5, ua.indexOf('.', msie)),
                    10
                );
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(
                    ua.substring(edge + 5, ua.indexOf('.', edge)),
                    10
                );
            }

            // other browser
            return false;
        },
        resolution: function () {
            return {
                height: $(window).height(),
                width: $(window).width()
            };
        },
        /**
         * Nukopijuoja paduoto elemento turinį į clipboard
         * @param {string|HTMLElement} tag - šio elemento turinys bus kopijuojamas
         * @param {boolean} notification - jeigu `true`, rodome informacinį pranešimą
         */
        copyTag: function (tag, notification) {
            tag = $(tag).eq(0)[0];

            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(tag);
            selection.removeAllRanges();
            selection.addRange(range);

            document.execCommand('copy');

            if (notification) {
                xdialog.notify.show(
                    'Nukopijuota',
                    window.getSelection(),
                    'success'
                );
            }

            selection.removeAllRanges();
        }
    },
    time: {
        seconds2time: function (second) {
            var hours = Math.floor(second / 3600),
                minutes = Math.floor((second - hours * 3600) / 60),
                seconds = second - hours * 3600 - minutes * 60,
                time = '';

            if (hours !== 0) {
                time = hours + ' val. ';
            }
            if (minutes !== 0 || time !== '') {
                minutes =
                    minutes < 10 && time !== '' ?
                    '0' + minutes :
                    String(minutes);
                time += minutes + ' min. ';
            }
            if (time === '') {
                time = seconds + '';
            } else {
                time += seconds < 10 ? '0' + seconds : String(seconds);
            }
            return time + ' sek.';
        },
		clock: function(duration, obj){
			var minutes = parseInt(duration / 60, 10),
				seconds = parseInt(duration % 60, 10),
				hours = parseInt(duration / 3600, 10),
				cl = '';
					
			hours = hours < 10 ? "0" + hours : hours;
			minutes = minutes < 10 ? "0" + minutes : minutes;
			seconds = seconds < 10 ? "0" + seconds : seconds;

			if(minutes >= 60) {
				minutes = '00';
			} 
				
			if(hours >= 24) {
				hours = '00';
			}

			if (obj.hours !== false){
				cl = hours+':'+minutes;
			} else {
				cl = minutes;
			}
			
			if (obj.seconds === false){
				return cl;
			}
			
			return cl + ':' + seconds;
		},
        getDiff: function (start, end) {
            return !end ?
                Math.floor((new Date().getTime() - start) / 1000) :
                Math.floor((end - start) / 1000);
        },
        getString: function (secs) {
            return secs.toHHMMSS();
        },
        getSeconds: function (time) {
            var a = time.split(':');
            return +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
        },
		countdown: function(duration, selector){
			var timer = duration,
				me = this,
				display = ((selector !== undefined) ? $(selector) : false),
				minutes,
				seconds,
				timerId,
				callback = function(){
					minutes = parseInt(timer / 60, 10);
					seconds = parseInt(timer % 60, 10);

					minutes = minutes < 10 ? "0" + minutes : minutes;
					seconds = seconds < 10 ? "0" + seconds : seconds;
					
					if (display !== false){
						display.text(minutes + ":" + seconds);
					}

					if (--timer < 0) {
						timer = duration;
						pause();
						if (display !== false){
							var timerInterval, quitseconds = 10;
							var obj = {
								title: 'Sesijos laikas baigėsi',
								html: 'Ar norite pratęsti sesiją?<br/><strong>'+me.clock(quitseconds, {hours:false})+'</strong>',
								timer:quitseconds*1000,
								cancelButtonColor: '#d33',
								cancelButtonColor: '#d33',
								confirmButtonText:'Taip',
								confirmButtonColor: '#3085d6',
								cancelButtonText:'Atsijungti',
								showCancelButton: true,
								showConfirmButton: true,
								allowOutsideClick: false,
								onOpen:function(){
									timerInterval = setInterval(function(){
										quitseconds--;
										swal.getContent().querySelector('strong').textContent = me.clock(quitseconds, {hours:false});
									}, 1000);
								},
								onClose:function(){
									clearInterval(timerInterval);
								}
							};
							
							
							xdialog.question.show(obj, function(result){
								if (result.value !== undefined){ //taip
									xcrud.json.load('/php/actions/countdown.php', {}, function(){
										start();
									});
								} else if (result.dismiss == 'cancel'){ //paspaude ne
									window.location = '/php/login/logout.php';
									return;
								} else if (result.dismiss == 'timer'){ //nesulauke atsakymo
									window.location = '/php/login/logout.php';
									return;
								} else {
									xlog(result);
								}
							});
						} else {
							xcrud.json.load('/php/actions/countdown.php', {}, function(){
								
							});
						}
					}
				},
				start = function(){
					timerId = setInterval(callback, 1000);
				},
				pause = function(){
					clearInterval(timerId);
					timerId = null;
				};
				
				start();
		}
    },
    /** Tikrina formos tusčius laukus, jeigu randą bent vieną `required` tuščią, grąžina `false`
     * @param {jQuery|HTMLElement|selector} form - forma, kurią validuos
     * @param {boolean} [addClasses=true] - Jeigu true, prideda klases
     * @return {boolean}
     */
    validate: function (form, addClasses) {
        form = $(form);

        if (form.length === 0) throw new Error('DĖMESIO MYGTUKAI NE FORMOJE');

        addClasses = addClasses === undefined ? true : addClasses;

        var required_group = form.find('[required-group]'),
            msg = {},
            obj = {
                phonecheck: {
                    onkeyup: false
                }
            };

        if (required_group.length > 1) {
            $.each(required_group, function () {
                obj[$(this).attr('name')] = {
                    require_from_group: [1, '[required-group]']
                };
                msg[$(this).attr('name')] = {
                    require_from_group: 'Vienas iš šių laukų yra privalomas'
                };
            });
        }

        form.validate({
            messages: msg
        });

        /** Grąžina true, jeigu elementas matomas
         * @param {jQuery|HTMLElement|selector} el
         * @return {boolean}
         */
        function isScrolledIntoView(el) {
            var $el = $(el),
                $window = $(window),
                docViewTop = $window.scrollTop(),
                docViewBottom = docViewTop + $window.height(),
                elemTop = $el.offset().top,
                elemBottom = elemTop + $el.height();

            return elemBottom <= docViewBottom && elemTop >= docViewTop;
        }

        var answer = form.valid(),
            first_error = form.closest('form').find('.error');

        // xbug
        if (!answer && $(first_error).length) {
            form
                .closest('form')
                .find('.error:not(:valid)')
                .eq(0)
                .focus();
            xdialog.notify.show('Klaida', 'Yra neužpildytų laukų', 'warning');
            if (!isScrolledIntoView($(first_error))) {
                $('html, body').animate({
                        scrollTop: first_error.offset().top - 100
                    },
                    300
                );
            }
        }

        return answer;
    },
    file: {
        download: function (url, params) {
            var f = $(
                    '<form target="_blank" method="POST" />'
                )
                .attr({
                    action: url
                })
                .appendTo(document.body);

            for (var i in params) {
                if (params.hasOwnProperty(i)) {
                    $('<input type="hidden" />')
                        .attr({
                            name: i,
                            value: params[i]
                        })
                        .appendTo(f);
                }
            }

            f.submit();

            f.remove();
        },
        /**
         * Patikrina ar paduotasis string yra nuotrauka. Naudojamas patikrinimui,
         * ar galima sugeneruoti preview thumbnail.
         * @param {string} path
         * @return {boolean}
         */
        isImage: function (path) {
            return /(img|png|gif|svg|jpe?g|tiff?)$/gi.test(path);
        },
        /**
         * Patikrina ar paduotasis string yra dokumentas. Naudojamas patikrinimui,
         * ar galima sugeneruoti preview thumbnail.
         * @param {string} path
         * @return {boolean}
         */
        isDocument: function (path) {
            return /(pdf|docx?|xlsx?)$/gi.test(path);
        }
    },
    image:{
        getOrientation : function(reader, file, callback) {
            var reader = new FileReader();
            reader.onload = function(e) {
        
                var view = new DataView(e.target.result);
                if (view.getUint16(0, false) != 0xFFD8)
                {
                    return callback(-2);
                }
                var length = view.byteLength, offset = 2;
                while (offset < length) 
                {
                    if (view.getUint16(offset+2, false) <= 8) return callback(-1);
                    var marker = view.getUint16(offset, false);
                    offset += 2;
                    if (marker == 0xFFE1) 
                    {
                        if (view.getUint32(offset += 2, false) != 0x45786966) 
                        {
                            return callback(-1);
                        }
        
                        var little = view.getUint16(offset += 6, false) == 0x4949;
                        offset += view.getUint32(offset + 4, little);
                        var tags = view.getUint16(offset, little);
                        offset += 2;
                        for (var i = 0; i < tags; i++)
                        {
                            if (view.getUint16(offset + (i * 12), little) == 0x0112)
                            {
                                return callback(view.getUint16(offset + (i * 12) + 8, little));
                            }
                        }
                    }
                    else if ((marker & 0xFF00) != 0xFF00)
                    {
                        break;
                    }
                    else
                    { 
                        offset += view.getUint16(offset, false);
                    }
                }
                return callback(-1);
            };
            reader.readAsArrayBuffer(file);
        },
        resetOrientation:function(srcBase64, srcOrientation, callback) {
            var img = new Image();	

            img.onload = function() {
            var width = img.width,
                height = img.height,
                canvas = document.createElement('canvas'),
                ctx = canvas.getContext("2d");
            

                console.log('width: ' + width + 'height: ' + height);
                // set proper canvas dimensions before transform & export
                if (4 < srcOrientation && srcOrientation < 9) {
                    canvas.width = height;
                    canvas.height = width;
                } else {
                    canvas.width = width;
                    canvas.height = height;
                }
            
                // transform context before drawing image
                switch (srcOrientation) {
                    case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
                    case 3: ctx.transform(-1, 0, 0, -1, width, height ); break;
                    case 4: ctx.transform(1, 0, 0, -1, 0, height ); break;
                    case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
                    case 6: ctx.transform(0, 1, -1, 0, height , 0); break;
                    case 7: ctx.transform(0, -1, -1, 0, height , width); break;
                    case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
                    default: break;
                }
                // draw image
                ctx.drawImage(img,0,0);
                if(width > 1920 && height > 1080) {
                    callback(canvas.toDataURL('image/jpeg', 0.4));
                } else {
                    callback(canvas.toDataURL());
                }
            };
            img.src = srcBase64;
        }
    },
    isImage: function (imageSrc, success, error) {
        var img = new Image();
        img.onload = success;
        img.onerror = error;
        img.src = imageSrc;
    },
    outlook: {
        close: function () {
            window.external.close();
        },
        sync: function () {
            window.external.sync();
        }
    },
	form:{
		disable:function(form){
			var pkInput = $('input[name="pk_val"]', form);
			//debugger;
			if (pkInput === null){
				return;
			}

			var pk = pkInput[0].value,
				isEdit = (pk !== '-1');
			
			if (isEdit) {
				var inputs = $('input:not([type="hidden"]), select, textarea', form),
					i;
			
				for (i = 0; i < inputs.length; i++) {
					inputs[i].setAttribute('disabled', true);
				}
			}
		}
	},
	clipboard:{
		copy:function(elementId){
			var $temp = $("<textarea rows='20' width='400px'>");
			$("body").append($temp);
			$temp.val($(elementId).text()).select();
			document.execCommand("copy");
			$temp.remove();
		}
	},
	keypress:{
		delay:function(ms){
			var timer = 0;
			return function(callback){
				clearTimeout(timer);
				timer = setTimeout(callback, ms);
			};
		},
		enter:function(e){
			return e.which === 13;
		},
		backspace:function(e){
			return e.which === 8;
		}
	},
	element:{
		events:function(element){
			return $._data(element.get(0), 'events');
		}
	}
};

/* exported xhelper */
var xhelper = new x_helper();